module.exports = __webpack_public_path__ + "assets/placeholder_img_profilo.0fc00657.svg";